
export const trackPinterestEvent = (event, data = {}) => {
  if (window.pintrk) {
    window.pintrk('track', event, data);
  }
};
